const pathObj = {
  loginUser: "/v1/admin/login",
  refreshToken: "/v1/admin/refresh-token",
  profileList: "/v1/admin/profile-list",
  downLineList: "/v1/admin/downline-list",
  affelatList: "/v1/admin/affiliate-list",
  addProfile: "/v1/admin/add-profile",
  metaData: "/v1/admin/meta-data",
  refreshAmount: "/v1/admin/refresh-amount",
  refreshExposureAmount: "/v1/admin/refresh-exposure-amount",
  userProfile: "/v1/admin/profile",
  activityLog: "/v1/admin/activity-logs",
  transactionLogs: "/v1/admin/transaction/logs",
  checkLimit: "/v1/admin/transaction/check-limit",
  transactionBetLogs: "/v1/admin/transaction/bet-logs",
  getInternationalCasinoBets: "/v1/admin/bets/casono-bet-history",
  matchList: "/v1/admin/match/add-match-list",
  updateAllAddMatchList: "/v1/admin/match/update-multiple",
  changePassword: "/v1/admin/change-password",
  updateMatchStatus: "/v1/admin/match/update-status",
  depositChips: "/v1/admin/deposit-chips",
  reportPlayer: "/v1/admin/report/player", reportMatch: "/v1/admin/report/match",
  searchUser: "/v1/admin/search-user",
  getgameControl: "/v1/admin/get-game-control",
  gameControl: "/v1/admin/game-control",
  lifeTimePL: "/v1/admin/lifetime-PL",
  casinoControl: "/v1/admin/casio-control",
  getcasinoControl: "/v1/admin/get-casio-control",
  sportSetting: "/v1/admin/sport-setting",
  EditProfile: "/v1/admin/edit-profile",
  getSportSettingNew: "/v1/admin/get-sport-setting",
  profileChangeStatus: "/v1/admin/profile-change-status",
  sportList: "/v1/admin/sport/list",
  getDashboard: "/v1/admin/dashboard",
  updateSportStatus: "/v1/admin/sport/update-status",
  withdrawal: "/v1/admin/withdrawal-amount",
  updateMatch: "/v1/admin/match/update-match",
  bankingCreate: "/v1/admin/transaction/create",
  createWebsite: "/v1/admin/create-website",
  listWebsite: "/v1/admin/list-website",
  userMessageCreate: "/v1/admin/message",
  userMessageList: "/v1/admin/message/list",
  userMessageDetail: "/v1/admin/message/detail",
  userMessageUpdate: "/v1/admin/message/update",
  importantMessage: "/v1/admin/message/important",
  messageStatusUpdate: "/v1/admin/message/status-update",
  updateUserReferenceAmount: "/v1/admin/update-reference-amount",
  updateAwcLimit: "/v1/admin/update-awc-limit",
  getBetslive: "/v1/admin/bets/live-bet-list",
  getBets: "/v1/admin/bets/bet-list",
  updateBetsStatus: "/v1/admin/bets/update-bet-status",
  rejectedBets: "/v1/admin/bets/rejected-bet-list",
  updateStatusRequestBets: "/v1/admin/match/update-status/",
  getFancyBetsDetails: "/v1/admin/match/detail",
  updateSettingLimit: "/v1/admin/match/update-match-limit-by-eventid",
  updateDefaultSetting: "/v1/admin/settings/global-limit-setting-update",
  getDefaultSetting: "/v1/admin/settings/global-limit-setting-list",
  beforeInplayLimit: "/v1/admin/settings/before-inplay-limit",
  siteSettingUpdate: "/v1/admin/site-setting/site-setting-update",
  matchFilterList: "/v1/admin/match/filter-list",
  fancyList: "/v1/admin/match/fancy-list",
  // resultFancyPremiumList: "/v1/admin/match/result-fancy-premium-list",
  resultFancyPremiumList: "/v1/admin/match/result-fancy-premium-list-new",
  eventFancyBets: "/v1/admin/bets/event-fancy-bets",
  fancyBetResult: "/v1/admin/bet-result/fancy",
  premiumFancyBetResult: "/v1/admin/bet-result/sportBook",
  tossBetResult: "/v1/admin/bet-result/toss",
  deleteFancy: "/v1/admin/match/fancy-delete",
  getExpouserData: "/v1/admin/exposure-list",
  updateExposure: "/v1/admin/update-exposure",
  updateCommission: "/v1/admin/update-commission",
  resultsSetMarker: "/v1/admin/match/result-match-list",
  addMatchAds: "/v1/admin/match/add-match-ad",
  betHistory: "/v1/admin/bets/bet-history",
  eventsBets: "/v1/admin/bets/events-bets",
  betProfitLoss: "/v1/admin/bets/profit-loss-bet",
  messageList: "/v1/admin/message/downline?type=downline",
  betfairResult: "/v1/admin/bet-result/betfair",
  tieResult: "/v1/admin/bet-result/tie",
  bookmakerResult: "/v1/admin/bet-result/bookmaker",
  resultTieandAbonded: "/v1/admin/match/update-status-by-eventid",
  reportDownline: "/v1/admin/report/downline",
  reportDownlineNew: "/v1/admin/report/downline-new",
  reportDownlineDetail: "/v1/admin/report/downline-list",
  reportMarketDetail: "/v1/admin/report/match-market",
  reportMatchMarketBets: "/v1/admin/report/match-market-bets",
  ACasinoprofitAndLossDownlineNew: "/v1/admin/report/casino-profit-loss",
  reportMarket: "/v1/admin/report/market",
  casinoMarket: "/v1/admin/report/casino",
  aprofitCasino: "/v1/admin/report/casino-profit-loss-by-date",
  setBookmaker: "/v1/cron/match-bookmaker-list-save",
  setFancy: "/v1/cron/match-fancy-list-save",
  setFancyupdate: "/v1/cron/fancy-list-save",
  setBookmakerUpdate: "/v1/cron/bookmaker-list-save",
  blockmarketList: "/v1/admin/tournament/series",
  updateBlockListinStatus: "/v1/admin/tournament/block-market",
  updateSportsListingStatus: "/v1/admin/sport/update-status",
  riskProfile: "/v1/admin/risk-profile-list",
  riskManagementDetails: "/v1/admin/match/detail",
  riskManagementSPortPremiumDetails: "/v1/admin/match/risk-premium-list-book",
  riskManagementFancy: "/v1/admin/match/risk-fancy-list",
  riskManagementPremium: "/v1/admin/match/risk-premium-list",
  updateFancyStatus: "/v1/admin/match/update-fancy-status",
  updatePremiumFancyStatus: "/v1/admin/match/update-premiumfancy-status",
  downlineDataRisk: "/v1/admin/match-profile-list",
  fancyPosition: "/v1/admin/match/fancy-bet-position",
  depositAmount: "/v1/admin/deposit-amount",
  lockedUserList: "/v1/admin/locked-user-list",
  userProfitLoss: "/v1/admin/profit-loss",
  riskMatchListBookmaker: "/v1/admin/match/risk-bookmaker-match-list",
  riskMatchList: "/v1/admin/match/risk-match-list",
  matchProfitLoss: "/v1/admin/match-profit-loss",
  userEventsBets: "/v1/admin/bets/user-events-bets",
  preMatchEventsBets: "/v1/admin/bets/prematch-events-bets",
  eventSessionBets: "/v1/admin/bets/event-session-bets",
  withdrawCasinoAmount: "/v1/wallet/agent-withdraw",
  tournamentList: "/v1/cron/tournament-list",
  cricketTournamentMatch: "/v1/cron/cricket-tournament-match",
  tennisTournamentMatch: "/v1/cron/tennis-tournament-match",
  soccerTournamentMatch: "/v1/cron/soccer-tournament-match",
  casinoHistory: "/v1/wallet/transaction-list",
  casinoWalletHistory: "/v1/wallet/transaction-history",
  updateWebsiteSetting: "/v1/admin/update-website-setting",
  getWebsiteLinkData: "/v1/admin/website-setting",
  getAECasinoBets: "/v1/admin/transaction/ae-casino-transaction",
  UserLiveBet: "/v1/admin/bets/bet-list-live",
  reciptUpload: "/v1/user/receipt-upload",
  //new routes
  reportByDownline: "/v1/admin/report/bydownline",
  casinoAllMarket: "/v1/admin/report/all-casino",
  ICasinoprofitAndLossDownlineNew:
    "/v1/admin/report/international-casino-profit-loss",
  blockCasinoList: "/v1/admin/sport/get-casino-market",
  updateBlockCasinoStatus: "/v1/admin/sport/casino-block-market",
  recentRegisteredUser: "/v1/admin/recent10-user-list",
  walletDeposit: "/v1/admin/deposit-list",
  walletWithdrwal: "/v1/admin/withdrawal-list",
  agentList: "/v1/admin/agent-list",
  saveDefaultAgent: "/v1/admin/save-default-agent",
  updateTransaction: "/v1/admin/update-transaction-status",

  updateTransactionNew: "/v1/admin/update-agent-transaction-status",
  updateTransactionId: "/v1/admin/update-transaction-id",
  getBankList: "/v1/admin/bank-list",
  addEditBank: "/v1/admin/add-edit-bank",
  deletBank: "/v1/admin/delete-bank",
  notificationCount: "/v1/admin/notification-count",
  walletHistory: "/v1/admin/withdrawal-history",
  agentWithdrawHistory: "/v1/admin/downline-withdrawal-history",
  depositHistory: "/v1/admin/deposit-history",
  bannerList: "/v1/admin/banner-list",
  deleteBanner: "/v1/admin/delete-banner",
  uploadBanner: "/v1/admin/banner-upload",
  addBanner: "/v1/admin/add-banner",
  updateRefrelCode: "/v1/admin/update-referal-code",
  promotionalOffer: "/v1/admin/promotional-offer",
  getpromotionalOffer: "/v1/admin/get-promotional-offer",
  commissionSetting: "",
  getMatchOdds: "/v1/cron/match-odds",
  getBookmakerOdds: "/v1/cron/bookmaker-odds",
  userSMSList: "/v1/admin/sms-list",
  getFancyOdds: "/v1/cron/fancy-odds",
  commisionReport: "/v1/admin/commision-report",
  withdrwaRequestList: "/v1/admin/agent-withdrawal-history",
  withdrwaRequestListNew: "/v1/admin/withdrawal-request-list",
  sendOTP: "/v1/admin/send-otp",
  otpVerify: "v1/admin/verify-otp",
  forgotPassword: "v1/admin/forgot-password",
  riskListAll: "/v1/admin/match/risk-profile-list-all",
  updateStatusBank: "/v1/admin/update-bank-status",
  withdrawalCheck: "/v1/admin/withdrawal-check",
  withdrawAmountLog: "/v1/admin/withdraw-amount-log",
  withdrawalProcessCheck: "/v1/admin/withdrawal-process-check",
  withdrawalProcessCheckUpdate: "/v1/admin/withdrawal-process-agent-update",
  turnoverList: "/v1/admin/turnover-list",
  kycUpload: "/v1/admin/kyc-upload",
  affEditDocument: "/v1/admin/aff-edit-document",
  kycDocument: "/v1/admin/kyc-document",
  kycLists: "/v1/admin/kyc-lists",
  deleteDocument: "/v1/admin/delete-document",
  updateKycStatus: "/v1/admin/update-kyc-status",
  editProfile: "/v1/admin/edit-profile",
  addOffer: "/v1/admin/add-update-offer",
  getOffer: "/v1/admin/get-offer",
  depositRequest: "/v1/admin/deposit-request",
  updateRequestStatus: "/v1/admin/update-deposit-request",
};
export default pathObj;
